/**
 * Answers the user typed into cover letter blanks like [PORTFOLIO], kept in
 * localStorage so the next generated letter can fill them in automatically.
 *
 * Answers are stored per user. The old shared key leaked one account's links
 * into another account's letters on the same browser, so it is removed on sight.
 */

export const LEGACY_KEY = "jz_cover_letter_details";
const KEY_PREFIX = `${LEGACY_KEY}:`;

const keyFor = (userId) => `${KEY_PREFIX}${userId}`;

const removeLegacyKey = () => {
  try {
    localStorage.removeItem(LEGACY_KEY);
  } catch {
    // storage unavailable
  }
};

export const loadCoverLetterDetails = (userId) => {
  removeLegacyKey();
  if (userId == null) return {};
  try {
    const parsed = JSON.parse(localStorage.getItem(keyFor(userId)) || "{}");
    return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
};

export const saveCoverLetterDetails = (userId, answers) => {
  if (userId == null) return;
  try {
    const existing = loadCoverLetterDetails(userId);
    localStorage.setItem(keyFor(userId), JSON.stringify({ ...existing, ...answers }));
  } catch {
    // storage unavailable or full
  }
};

/** Remove every account's saved answers, except `keepUserId`'s when given. */
export const clearCoverLetterDetails = (keepUserId = null) => {
  removeLegacyKey();
  try {
    const keep = keepUserId == null ? null : keyFor(keepUserId);
    const stale = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && key.startsWith(KEY_PREFIX) && key !== keep) stale.push(key);
    }
    stale.forEach((key) => localStorage.removeItem(key));
  } catch {
    // storage unavailable
  }
};
